/**
 * FDT/Findify AJAX Add to Cart
 * Intercepts add-to-cart button clicks from Findify Custom Filter & Search app
 * and performs AJAX add-to-cart instead of standard form submission.
 */
(function() {
  'use strict';

  // Selectors for FDT add-to-cart buttons
  var FDT_ADD_TO_CART_SELECTORS = [
    '.fdt-add-to-cart',           // Product with variants (after selection)
    '.fdt-button-add-to-cart'     // Simple product (no variants)
  ];

  // SVG checkmark HTML (matching theme's checkmark)
  var CHECKMARK_SVG = '<svg x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" class="checkmark"><path fill="none" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11"></path></svg>';

  /**
   * Show loading state on button (matching theme's animation)
   */
  function showLoadingState(button) {
    button.setAttribute('disabled', 'disabled');
    button.classList.add('disabled');
    
    var span = button.querySelector(':scope > span');
    if (span) {
      span.classList.remove('fadeInDown');
      span.classList.add('animated', 'zoomOut');
    }
  }

  /**
   * Hide loading state on button
   */
  function hideLoadingState(button) {
    button.removeAttribute('disabled');
    button.classList.remove('disabled');
    
    var span = button.querySelector(':scope > span');
    if (span) {
      span.classList.remove('zoomOut');
      span.classList.add('fadeInDown');
    }
    
    // Remove checkmark
    var checkmark = button.querySelector('.checkmark');
    if (checkmark) {
      checkmark.classList.remove('checkmark-active');
    }
  }

  /**
   * Show success state on button (matching theme's checkmark animation)
   */
  function showSuccessState(button) {
    // Create checkmark if it doesn't exist
    var checkmark = button.querySelector('.checkmark');
    if (!checkmark) {
      button.insertAdjacentHTML('beforeend', CHECKMARK_SVG);
      checkmark = button.querySelector('.checkmark');
    }
    
    // Activate checkmark animation
    if (checkmark) {
      checkmark.classList.add('checkmark-active');
    }
    
    setTimeout(function() {
      hideLoadingState(button);
    }, 1000);
  }

  /**
   * Close FDT variant selector modal
   */
  function closeFdtModal(button) {
    // Find the swatch wrapper and click its close button
    var form = button.closest('form');
    if (!form) return;
    
    var swatchWrapper = form.querySelector('fdt-swatch-wrapper');
    if (swatchWrapper) {
      var closeBtn = swatchWrapper.querySelector('.fdt-selector-close-button');
      if (closeBtn) {
        closeBtn.click();
      }
    }
  }

  /**
   * Close cart drawer after delay
   */
  var cartCloseTimer = null;
  
  function closeCartDrawerAfterDelay(delay) {
    var $ = window.jQuery || window.$;
    if (!$) return;
    
    // Clear any existing timer
    if (cartCloseTimer) {
      clearTimeout(cartCloseTimer);
    }
    
    cartCloseTimer = setTimeout(function() {
      $('.cart-container').removeClass('active_link');
      $('body').removeClass('blocked-scroll');
      cartCloseTimer = null;
    }, delay);
  }

  /**
   * Rebuild mini cart HTML from cart data (copy of theme's refreshCart logic)
   */
  function rebuildMiniCart(cartData) {
    var $ = window.jQuery || window.$;
    if (!$) return;

    // Update cart count
    var cartCountEls = $('.cart_count');
    cartCountEls.each(function() {
      var currentText = $(this).text() || '0';
      $(this).text(currentText.replace(/[0-9]+/, cartData.item_count));
    });

    if (cartData.item_count === 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $('[data-cart-form]').addClass('hidden');
      return;
    }

    $('.js-empty-cart__message').addClass('hidden');
    $('[data-cart-form]').removeClass('hidden');

    var itemsHtml = '';
    var discountsHtml = '';
    var subtotalHtml = '';
    var savingsHtml = '';
    var totalSavings = 0;

    $.each(cartData.items, function(index, item) {
      var lineId = index + 1;
      var discountText = '';
      
      // Build discount text
      if (item.discounts && item.discounts.length > 0) {
        for (var d = 0; d < item.discounts.length; d++) {
          discountText = '<p class="notification-discount meta">' + item.discounts[d].title + '</p>';
        }
      }

      itemsHtml += '<li class="mini-cart__item" data-cart-item data-line-id="' + lineId + '" data-variant-id="' + item.id + '">';
      itemsHtml += '<a href="' + item.url + '">';
      
      if (item.image) {
        var imgSrc = item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '');
        itemsHtml += '<div class="cart_image"><img src="' + imgSrc + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" /></div>';
      }
      itemsHtml += '</a>';
      
      itemsHtml += '<div class="mini-cart__item-content">';
      itemsHtml += '<div class="mini-cart__item-title"><a href="' + item.url + '">' + item.title + '</a>';
      
      if (item.selling_plan_allocation) {
        itemsHtml += '<div class="meta">' + item.selling_plan_allocation.selling_plan.name + '</div>';
      }
      
      itemsHtml += '</div>';
      itemsHtml += '<div class="mini-cart__item-price">';
      
      var moneyFormat = $('body').data('money-format') || '{{amount}} CHF';
      
      if (item.original_price > item.final_price) {
        itemsHtml += '<span class="money sale">' + Shopify.formatMoney(item.final_price, moneyFormat) + '</span> ';
        itemsHtml += '<span class="money was_price">' + Shopify.formatMoney(item.original_price, moneyFormat) + '</span>';
        totalSavings += (item.original_price - item.final_price) * item.quantity;
      } else {
        if (item.final_price > 0) {
          itemsHtml += '<span class="money">' + Shopify.formatMoney(item.final_price, moneyFormat) + '</span>';
        } else {
          itemsHtml += '<span>' + (window.PXUTheme && window.PXUTheme.translation && window.PXUTheme.translation.cart_free_text || 'Free') + '</span>';
        }
      }
      
      itemsHtml += '</div>';
      
      if (item.price > item.final_price && discountText) {
        itemsHtml += discountText;
      }
      
      // Quantity box
      itemsHtml += '<div class="product-quantity-box">';
      itemsHtml += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
      itemsHtml += '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity + '" data-cart-quantity-input="mini-cart" />';
      itemsHtml += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
      itemsHtml += '</div></div></div>';
      
      // Remove button
      itemsHtml += '<a href="/cart/change?line=' + lineId + '&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="' + lineId + '" data-remove-item="mini-cart"><span class="remove-icon"></span></a>';
      itemsHtml += '</li>';
    });

    // Cart level discounts
    if (cartData.cart_level_discount_applications) {
      for (var i = 0; i < cartData.cart_level_discount_applications.length; i++) {
        var discount = cartData.cart_level_discount_applications[i];
        var discountAmount = Shopify.formatMoney(discount.total_allocated_amount, $('body').data('money-format'));
        discountsHtml += '<span class="cart_discounts--title">' + discount.title + '</span>';
        discountsHtml += '<span class="cart_discounts--price">-<span class="money">' + discountAmount + '</span></span>';
      }
    }

    // Subtotal
    subtotalHtml = '<span class="right"><span class="money">' + Shopify.formatMoney(cartData.total_price, $('body').data('money-format')) + '</span></span>';
    subtotalHtml += '<span>' + (window.PXUTheme && window.PXUTheme.translation && window.PXUTheme.translation.cart_subtotal_text || 'Subtotal') + '</span>';

    // Savings
    totalSavings += cartData.total_discount;
    if (window.PXUTheme && window.PXUTheme.theme_settings && window.PXUTheme.theme_settings.display_savings && totalSavings > 0) {
      savingsHtml = '<span class="right"><span class="money">' + Shopify.formatMoney(totalSavings, $('body').data('money-format')) + '</span></span>';
      savingsHtml += '<span>' + (window.PXUTheme.translation && window.PXUTheme.translation.cart_savings_text || 'Savings') + '</span>';
    }

    // Update DOM
    $('.js-cart_items').html(itemsHtml);
    $('.js-cart_discounts').html(discountsHtml);
    $('.js-cart_subtotal').html(subtotalHtml);
    $('.js-cart_savings').html(savingsHtml);

    // Currency conversion if enabled
    if (window.PXUTheme && window.PXUTheme.currency && window.PXUTheme.currency.show_multiple_currencies && window.currencyConverter) {
      window.currencyConverter.convertCurrencies();
    }
  }

  /**
   * Open cart drawer
   */
  function openCartDrawer() {
    var $ = window.jQuery || window.$;
    if (!$) return;

    // Close fancybox if open
    if (typeof $.fancybox !== 'undefined' && $('body').hasClass('fancybox-active')) {
      $.fancybox.close();
    }

    // Deactivate other dropdowns
    $('.dropdown_link').removeClass('active_link');

    // Open cart container
    if ($('#header').is(':visible')) {
      $('#header .cart-container').addClass('active_link');
    } else if ($('.sticky_nav--stick').length) {
      $('.sticky_nav .cart-container').addClass('active_link');
    } else {
      $('.top-bar .cart-container').addClass('active_link');
    }

    // Handle mobile scroll blocking
    if (window.PXUTheme && window.PXUTheme.media_queries && window.PXUTheme.media_queries.medium.matches) {
      $('body').addClass('blocked-scroll');
      
      var header = document.getElementById('header');
      if (header && header.classList.contains('mobile_nav-fixed--false')) {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
    }
  }

  /**
   * Get the correct variant ID from FDT form
   * FDT forms have multiple input[name="id"] - we need the one inside fdt-swatch-wrapper
   */
  function getVariantId(form) {
    // First, try to find input inside fdt-swatch-wrapper (for products with variants)
    var swatchWrapper = form.querySelector('fdt-swatch-wrapper');
    if (swatchWrapper) {
      var swatchInput = swatchWrapper.querySelector('input[name="id"]');
      if (swatchInput && swatchInput.value) {
        return swatchInput.value;
      }
    }

    // Fallback: get the last input[name="id"] in the form (usually the one updated by FDT)
    var allIdInputs = form.querySelectorAll('input[name="id"]');
    if (allIdInputs.length > 0) {
      // Return the last one, which is typically the one FDT updates
      return allIdInputs[allIdInputs.length - 1].value;
    }

    return null;
  }

  /**
   * Check if button is inside a variant modal
   */
  function isInsideVariantModal(button) {
    return button.closest('fdt-swatch-wrapper') !== null;
  }

  /**
   * Handle add to cart AJAX
   */
  function handleAddToCart(event) {
    var button = event.target.closest(FDT_ADD_TO_CART_SELECTORS.join(', '));
    if (!button) return;

    // Only handle submit buttons with name="add"
    if (button.getAttribute('name') !== 'add') return;

    // Find the form
    var form = button.closest('form');
    if (!form) return;

    // Prevent default form submission
    event.preventDefault();
    event.stopPropagation();

    // Get variant ID from form
    var variantId = getVariantId(form);
    if (!variantId) {
      console.error('FDT AJAX Cart: No variant ID found');
      return;
    }

    // Check if inside variant modal
    var inModal = isInsideVariantModal(button);

    console.log('FDT AJAX Cart: Adding variant', variantId, inModal ? '(from modal)' : '');

    // Show loading state
    showLoadingState(button);

    // Make AJAX request
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1
      })
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(data) {
          throw new Error(data.description || 'Failed to add to cart');
        });
      }
      return response.json();
    })
    .then(function(addedItem) {
      console.log('FDT AJAX Cart: Item added', addedItem);
      // Fetch updated cart data
      return fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      });
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(cartData) {
      console.log('FDT AJAX Cart: Cart updated', cartData);
      
      // Show success animation
      showSuccessState(button);
      
      // Close FDT modal after checkmark animation completes (1 second delay)
      if (inModal) {
        setTimeout(function() {
          closeFdtModal(button);
        }, 1000);
      }
      
      // Wait a bit then open cart (after modal closes)
      setTimeout(function() {
        // Rebuild and open cart
        rebuildMiniCart(cartData);
        openCartDrawer();
        
        // Auto-close cart drawer after 3 seconds
        closeCartDrawerAfterDelay(3000);
      }, inModal ? 1200 : 100);
    })
    .catch(function(error) {
      console.error('FDT AJAX Cart Error:', error);
      hideLoadingState(button);
      
      // Show error message
      var warningHtml = '<p class="warning animated bounceIn">' + error.message + '</p>';
      var existingWarning = form.parentElement.querySelector('.warning');
      if (existingWarning) {
        existingWarning.remove();
      }
      form.insertAdjacentHTML('afterend', warningHtml);
    });
  }

  /**
   * Initialize event listeners
   */
  function init() {
    // Use event delegation on document for dynamically loaded content (FDT loads products dynamically)
    document.addEventListener('click', handleAddToCart, true);
    
    console.log('FDT AJAX Cart: Initialized');
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
